module.exports = __webpack_public_path__ + "Content/desktop/img/long-angle.0d84383e.svg";